// Single source of truth for the Security Hub portal poll cadence.
export const POLL_INTERVAL_MS = 3000;
